<form (ngSubmit)="onSubmit()" [formGroup]="form">
  <div *ngFor="let question of questions" class="question p-bottom-15">
    <app-dynamic-form-question [question]="question" [form]="form" [isSubmitted]="isSubmitted" #formQuestion></app-dynamic-form-question>
  </div>
  <div class="text-center m-bottom-10 m-top-10" *ngIf="!disabled && showSubmitButton">
    <button class="btn-frankli-round btn-frankli-green" type="submit">Submit</button>
  </div>
</form>
